// Vložit do pole, pokud tam ještě není
export const pushUnique = (arr: string[], value: string): void => {
  if (arr.indexOf(value) === -1) {
    arr.push(value);
  }
};
